// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // IMPORTANT: Do not read this directly from components. Use `React.useContext`.
  'ant-prefix': 'du-bois',
};
